import axios from 'axios';

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL ? `${import.meta.env.VITE_API_URL}/api` : 'http://localhost:8000/api',
 headers: {
  // 'Content-Type': 'multipart/form-data',
  'Accept': 'application/json',
}
,
  withCredentials: true // Enable sending cookies with requests
});

// Add request interceptor to include JWT token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (token) {
      // Normalize header to ensure single Bearer prefix
      const hasBearer = /^Bearer\s+/i.test(token);
      config.headers.Authorization = hasBearer ? token : `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration with auto-redirect
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 errors (token expired/missing) - auto-redirect to login
    if (error.response?.status === 401) {
      try {
        const currentPath = window.location?.pathname || '';

        // Don't redirect if already on login page, login endpoint, or driver testing pages
        if (currentPath !== '/' && !error.config.url.includes('/login') && !currentPath.startsWith('/driver-test/')) {
          console.log('🔒 Authentication token expired/missing - redirecting to login');

          // Clear any cached user data
          if (window.queryClient) {
            window.queryClient.clear();
          }

          // Preserve current path for post-login redirect
          const encodedFrom = encodeURIComponent(currentPath + (window.location.search || ''));
          const loginUrl = `/?from=${encodedFrom}`;

          // Use replace to prevent back button issues
          window.location.replace(loginUrl);
        }
      } catch (e) {
        console.error('Error during auth redirect:', e);
        // Fallback: redirect to login without preserving path (except driver testing)
        if (window.location.pathname !== '/' && !window.location.pathname.startsWith('/driver-test/')) {
          window.location.replace('/');
        }
      }

      return Promise.reject({
        ...error,
        isAuthError: true
      });
    }

    return Promise.reject(error);
  }
);

export default apiClient;